import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Modal, ModalContent } from "semantic-ui-react";
import { IoCloseSharp } from "react-icons/io5";
import store from "../../redux/store";
import { withRouter } from "react-router-dom";
import { PROMPT_ADD_TO_HOME_SCREEN } from "../../redux/types";

const PWAInstallModal = (props) => {
  let darkMode = useSelector((state) => state.settings.darkMode);
  let isModalOpenState = useSelector((state) => state.world.mobilePWAModal);
  let isModalOpen = isModalOpenState;
  let mobileOSType = useSelector((state) => state.world.mobileOSType);
  const [checkBx, setCheckBx] = useState(false);
  const proposalEvent = useSelector((state) => state.pwaInstall.proposalEvent);

  const _installPWA = () => {
    if (!proposalEvent) {
      return;
    }

    store.dispatch({
      type: PROMPT_ADD_TO_HOME_SCREEN,
    });
    proposalEvent.prompt();
  };

  useEffect(() => {
    let backdropContainer = document.querySelector(".dimmer");
    let contentContainer = document.querySelector(".content");
    if (backdropContainer) {
      backdropContainer.style.backgroundColor = "rgba(0,0,0,0.2)";
    }

    if (contentContainer) {
      contentContainer.style.borderRadius = "10px";
    }
  }, []);

  const _onModalCheck = (e) => {
    setCheckBx(e.target.checked);
  };

  return (
    <Modal
      size={"mini"}
      centered={false}
      onClose={() => {
        store.dispatch({ type: "SET_MOBILE_PWA_MODAL", payload: false });
        localStorage.setItem("hideInstallPwaModal", checkBx);
      }}
      onOpen={() => {
        store.dispatch({ type: "SET_MOBILE_PWA_MODAL", payload: true });
      }}
      open={isModalOpen}
      className={
        darkMode ? "pwa-install-modal-dark" : "pwa-install-modal-light"
      }
      style={{ borderRadius: "10px", marginTop: "50px" }}
    >
      <ModalContent
        style={{
          backgroundColor: darkMode ? "#3c3c3c" : "#edf0f5",
          padding: "0px",
        }}
      >
        <div
          className="subs-close"
          style={{
            marginTop:
              mobileOSType && mobileOSType === "Android" ? "15px" : "7px",
          }}
        >
          <IoCloseSharp
            style={{ fontSize: "20px", color: darkMode ? "#fff" : "#000" }}
            onClick={() => {
              store.dispatch({
                type: "SET_MOBILE_PWA_MODAL",
                payload: false,
              });
              localStorage.setItem("hideInstallPwaModal", checkBx);
            }}
          />
        </div>
        <div
          className="pwa-install-modal-content"
          style={{ color: darkMode ? "#ffffff" : "#000000" }}
        >
          {/* content */}
          {mobileOSType && mobileOSType === "Android" && (
            <div className="pwa-android-instructions">
              <button onClick={_installPWA} className="button-dark">
                Install PikiLinks
              </button>
              <div className="action-checkbox">
                <input type="checkbox" onChange={_onModalCheck} />
                <span>Don't show this again</span>
              </div>
            </div>
          )}
          {mobileOSType && mobileOSType === "IOS" && (
            <div className="pwa-ios-instructions">
              <b>Install PikiLinks on iPhone/iOS Devices</b>
              <div
                className="separator"
                style={{ backgroundColor: darkMode ? "#fff" : "#000" }}
              ></div>
              <span>
                1. Find the share button(square with upward arrow) located at
                the top-right of Safari-browser
              </span>
              <span>2. Tap the share button</span>
              <span>3. Scroll down and tap Add to Home Screen</span>
              <span>4. Tap Add</span>
              <div className="action-checkbox">
                <input
                  type="checkbox"
                  onChange={_onModalCheck}
                  checked={checkBx}
                />
                <span>Don't show this again</span>
              </div>
            </div>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
};

export default withRouter(PWAInstallModal);
